<template>
  <section v-show="show" class="viewsrhwxEvaluate_CheckInBefore">
    <Empty :text="text"></Empty>
    <van-button type="primary" block class="btnStyle2" @click="goBack"
      >返回</van-button
    >
  </section>
</template>

<script>
import Empty from "@/components/tips/Empty";
export default {
  name: "viewsrhwxEvaluate_CheckInBefore",

  props: [""],

  data() {
    return {
      show: false,
      text: "未找到有效的装车记录，请完成装车后再试。"
    };
  },

  computed: {},

  watch: {},

  components: { Empty },

  mixins: [],

  beforeCreate() {},

  created() {
    this.$common
      .http({
        url: "/api/queue/driver/pre_operate_info",
        data: {
          sub_com_id: this.$route.query.sub_com_id
        }
      })
      .then(res => {
        console.log(res);
        let data = res.data.data;

        if (Number(data.other_company_state) === 1) {
          this.text = "请先结束其他厂区下的预约业务，再重新进入。";
          this.show = true;
        } else if (Number(data.info_tarpaulin_status) === 1) {
          if (Number(data.have_comfirm_tarpaulin) === 1) {
            this.$router.replace({
              path: "/rhwxEvaluateResult",
              query: this.$route.query
            });
          } else {
            // 进入盖篷布确认页面
            this.$router.replace({
              path: "/rhwxEvaluateCheckIn",
              query: {
                app_id: this.$route.query.app_id,
                map_type: this.$route.query.map_type,
                com_id: this.$route.query.com_id,
                sub_com_id: this.$route.query.sub_com_id
              }
            });
          }
        } else if (
          Number(data.other_company_state) === 0 &&
          Number(data.info_tarpaulin_status) === 0
        ) {
          this.show = true;
        } else {
          console.log();
        }
      });
  },

  beforeMount() {},

  mounted() {},

  activated() {},

  methods: {
    goBack() {
      this.$router.push({
        path: "/rhwxIntoCodeAllPath",
        query: this.$route.query
      });
    }
  }
};
</script>
<style lang="less" scoped>
.viewsrhwxEvaluate_CheckInBefore {
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  .btnStyle2 {
    margin-top: 25px !important;
  }
}
</style>
<style lang="less">
.viewsrhwxEvaluate_CheckInBefore {
  .imgMobile {
    width: 300px !important;
  }
}
</style>
